export const BM_UNITS_QUERY_PARAMETERS_BATCH_SIZE = 100;
